/**
 * @file headerFilterCell.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Tuesday, 16th February 2021 6:28:33 am
 * @copyright 2015 - 2021 SKAT LLC, Delive LLC
 * @flow
 */
import type { ElementEvent } from 'web-panel/types'

import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBackspace } from '@fortawesome/free-solid-svg-icons'
import { __ } from 'web-panel/globals'
import autoBind from 'react-autobind'
import cn from 'classnames'

library.add(faBackspace)

type Props = {
  value: string,
  columnName: string,
  style: {},
  tabIndex: number,
  onChange: (value: string, columnName: string) => void | Promise<void>
}

class HeaderFilterCell extends React.PureComponent<Props> {
  constructor (props: Props) {
    super(props)
    autoBind(this)
  }

  handleChange (event : ElementEvent) {
    this.props.onChange(event.target.value, this.props.columnName)
  }

  handleReset () {
    this.props.onChange('', this.props.columnName)
  }

  render () : React.Node {
    const { value, style, tabIndex } = this.props
    return (
      <div className={cn('filterCell', { active: Boolean(value) })} style={style}>
        <input
          value={value}
          tabIndex={tabIndex}
          placeholder={__('NOT_SET')}
          onChange={this.handleChange}
          type='text'
          className='filterField'
        />
        <FontAwesomeIcon
          title={__('RESET')}
          icon='backspace'
          className={cn('reset-icon', { active: Boolean(value) })}
          onClick={this.handleReset}
        />
      </div>
    )
  }
}

export default HeaderFilterCell
